<template>
    <v-dialog
        v-model="dialog"
        :max-width="options.width"
        :style="{ zIndex: options.zIndex }"
        @keydown.esc="cancel"
    >
        <v-card>
            <v-toolbar dark :color="options.color" dense flat>
                <v-toolbar-title
                    class="text-body-2 font-weight-bold grey--text"
                >
                    Message
                </v-toolbar-title>
            </v-toolbar>

            <v-card-text class="message-container">
                <v-row align="center" class="mt-3" dense :gutter="16">
                    <label class="label label-text-field mb-1">
                        Enter message to send
                    </label>
                    <v-col cols="12" style="padding: 0">
                        <v-textarea
                            placeholder="Type your message"
                            background-color="grey lighten-2"
                            v-model="message"
                            :rules="[rules.required]"
                            counter="3000"
                            :maxlength="3000"
                            style="font-size: 14px"
                            rows="5"
                            class="message-text mt-0 pt-0"
                        ></v-textarea>
                    </v-col>
                </v-row>
            </v-card-text>

            <v-card-actions class="pt-3">
                <v-spacer></v-spacer>
                <v-btn
                    color="grey"
                    text
                    class="body-2 font-weight-bold"
                    @click.native="cancel"
                    :disabled="loading"
                >
                    Cancel
                </v-btn>
                <v-btn
                    color="primary"
                    class="body-2 font-weight-bold"
                    outlined
                    @click.native="agree"
                    :disabled="message.trim().length === 0 || loading"
                >
                    Send
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<style lang="scss">
    .v-card__text {
        font-size: 14px;
    }
    .message-text textarea {
        padding: 10px;
        line-height: 1.5rem;
    }
</style>
<style lang="scss" scoped>
    .message-container {
        padding-top: 0 !important;
        padding-bottom: 0 !important;
    }
</style>

<script>
    import { viewhttp } from "@/config/http";

    export default {
        data() {
            return {
                dialog: false,
                resolve: null,
                reject: null,
                message: "",
                options: {
                    color: "grey lighten-3",
                    width: 400,
                    zIndex: 200,
                    noconfirm: false,
                },
                campaignid: null,
                profile: null,
                loading: false,
                rules: {
                    required: (value) =>
                        (value != null && value !== "") || "Required.",
                },
            };
        },
        props: {
            getRecentCampaignID: {
                type: Function,
                default: () => {},
            },
            campaigns: {
                type: Array,
                default: () => [],
            },
        },
        methods: {
            open(campaignid, profile) {
                this.dialog = true;
                this.profile = profile;
                if (campaignid === "*") {
                    this.campaignid = this.getRecentCampaignID(profile.tags);
                } else {
                    this.campaignid = campaignid;
                }
                return new Promise((resolve, reject) => {
                    this.resolve = resolve;
                    this.reject = reject;
                });
            },
            async agree() {
                try {
                    this.loading = true;
                    const endpoint = `/currentuser/control/queue`;
                    const campaign = this.campaigns.find(
                        (campaign) => campaign.id === this.campaignid,
                    );

                    const target = campaign.target;
                    let profile = undefined;
                    if (target === "regular") {
                        profile = this.profile.Profile;
                    } else if (target === "salesnav") {
                        profile = this.profile.SalesProfile;
                    } else {
                        profile = this.profile.RecruiterProfile;
                    }

                    if (profile === undefined) {
                        profile = this.profile.Profile;
                    }

                    const body = [
                        {
                            params: {
                                profile,
                                force: true,
                                campaignid: this.campaignid,
                                profileid: this.profile.id,
                                messagetext: this.message,
                            },
                            command: "message",
                        },
                    ];
                    await viewhttp.post(endpoint, body);
                } catch (error) {
                    console.error("error:", error);
                } finally {
                    this.loading = false;
                    this.message = "";
                }

                this.resolve(true);
                this.dialog = false;
            },
            cancel() {
                this.resolve(false);
                this.dialog = false;
            },
        },
    };
</script>
